import { RawFieldPTableDefault } from "@/common/components";
import { RawTransactionDefaultFields } from "@/entities/transaction-default-fields/transactionDefaultFields.type";

export class TransactionDefaultFields {
  transactionPage: {
    fields: RawFieldPTableDefault[];
  };
  version: string;

  constructor(data: RawTransactionDefaultFields) {
    this.transactionPage = data.transactionPage;
    this.version = data.version;
    if (!this.transactionPage) {
      this.transactionPage = {
        fields: [],
      };
    }
  }
}
